"use client";

import { c as _c } from "react/compiler-runtime";
import React, { memo } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import ImageComponent from "@/components/ui/image";
import { getImageProps } from "next/image";
import HeroMain from "@/assets/images/v2/hero-main.webp";
import HeroSecondary from "@/assets/images/v2/hero-secondary.webp";
const BEST_SELLER_URL = "/listing/the-best-sellers?id=10";
export const DesktopHero = memo(() => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getImageProps({
      alt: "Luxury gift packaging",
      src: HeroMain,
      fill: true,
      fetchPriority: "high",
      loading: "eager",
      sizes: "(max-width: 1920px) 50vw, 33vw"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    props: t1
  } = t0;
  let desktopProps;
  let desktopSrcSet;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const {
      srcSet: t2,
      alt: _desktopAlt,
      ...t3
    } = t1;
    desktopSrcSet = t2;
    desktopProps = t3;
    $[1] = desktopProps;
    $[2] = desktopSrcSet;
  } else {
    desktopProps = $[1];
    desktopSrcSet = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    t3 = <span className="text-[#735C00] italic">Most Beautiful</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h1 className="font-lora text-[#005F52] mb-8 text-5xl leading-[1.1]">Discover India's {t2}{t3} <br />Gifts.</h1>;
    t5 = <p className="max-w-md font-outfit text-[#3E4946] mb-8 text-lg leading-[1.625]">{"Craft coffee, artisanal tea, d\xE9cor, art, chocolates & more - every product from India's finest brands that choose quality over mass production."}</p>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="z-10 md:col-span-5">{t4}{t5}<div className="flex gap-4"><Link href={BEST_SELLER_URL} prefetch={true}><Button size="lg" className="bg-gradient-to-br from-[#005F52] to-[#037A6A] font-lora uppercase text-white shadow-lg rounded-full py-7 px-8 font-extrabold transition-all duration-150 ease-out hover:-translate-y-0.5 hover:shadow-xl" aria-label="Explore Collections">Explore Collections</Button></Link></div></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="z-0 aspect-[3/4] w-[80%] rotate-2 shadow-2xl rounded-xl relative overflow-hidden"><picture className="absolute inset-0 w-full h-full"><source media="(max-width: 1023px)" srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" /><source media="(min-width: 1024px)" srcSet={desktopSrcSet} /><img alt="Luxury gift packaging" {...desktopProps} className="object-cover object-[25%_center] w-full h-full absolute inset-0" /></picture></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="bg-[#F7F3F2] items-center w-full h-full flex relative overflow-hidden"><div className="grid grid-cols-1 md:grid-cols-12 items-center gap-8 w-full max-w-[1440px] mx-auto px-8">{t6}<div className="h-full flex justify-end items-center relative md:col-span-7 lg:translate-x-10 lg:pl-12 lg:pr-20 xl:translate-x-16 xl:pr-32">{t7}<div className="z-20 aspect-square w-[50%] -rotate-3 border-8 border-[#FCF8F8] shadow-xl rounded-xl absolute bottom-12 -left-12 overflow-hidden"><ImageComponent alt="Artisan products" className="object-cover w-full h-full" src={HeroSecondary} fill={true} sizes="(max-width: 1023px) 1vw, (max-width: 1280px) 30vw, 374px" /></div></div></div></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
});
DesktopHero.displayName = "DesktopHero";